module.exports = __webpack_public_path__ + "img/C2_Net_Banking.de544620.png";